import { apiClient } from './apiClient';

export class RedFlagResolutionService {
    constructor() {
        this.BASE_URL = '/red-flag-resolution-forms';
    }

    /**
     * Generate resolution form for a red flag
     * @param {string} redFlagId - Red Flag ID
     * @returns {Promise<Object>} Generated form
     */
    async generateResolutionForm(redFlagId) {
        try {
            const response = await apiClient.post(`${this.BASE_URL}/generate/${redFlagId}`, {});
            return response
        } catch (error) {
            console.error('Error generating red flag form:', error);
            throw error;
        }
    }

    async getResolutionForm(formId) {
        try {
            const response = await apiClient.get(`${this.BASE_URL}/${formId}`);
            return response
        } catch (error) {
            console.error('Error fetching resolution form:', error);
            throw error;
        }
    }

    async updateResolutionForm(formId, updates) {
        try {
            const response = await apiClient.put(`${this.BASE_URL}/${formId}`, updates);
            return response
        } catch (error) {
            console.error('Error updating resolution form:', error);
            throw error;
        }
    }

    async completeResolutionForm(formId, completionData) {
        try {
            const response = await apiClient.post(`${this.BASE_URL}/${formId}/complete`, completionData);
            return response
        } catch (error) {
            console.error('Error completing resolution form:', error);
            throw error;
        }
    }

    async getFormsByRedFlag(redFlagId) {
        try {
            const response = await apiClient.get(`${this.BASE_URL}/by-red-flag/${redFlagId}`);
            return response
        } catch (error) {
            console.error('Error fetching forms by red flag:', error);
            throw error;
        }
    }

    async getFormTemplate(formType) {
        try {
            const response = await apiClient.get(`${this.BASE_URL}/templates/${formType}`);
            return response
        } catch (error) {
            console.error('Error fetching form template:', error);
            throw error;
        }
    }
}

export const redFlagResolutionService = new RedFlagResolutionService();
export default redFlagResolutionService;
